import { useCallback, useRef } from 'react';

import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';

/**
 * Persists a value between renders, but keeps it up-to-date if it changes.
 * @param value the value or function to persist
 */
export function useCallbackRef<T>(
  ...refs: (React.MutableRefObject<T> | ((instance: T) => void) | null)[]
) {
  const cache = useRef(refs);

  useIsomorphicLayoutEffect(() => {
    cache.current = refs;
  }, [refs]);

  return useCallback(
    (value?: T) => {
      for (const ref of cache.current) {
        if (ref == null) continue;
        if (typeof ref === 'function') ref(value);
        else ref.current = value;
      }
    },
    [cache]
  );
}
